import { useEffect, useRef } from 'react';

/**
 * Determine whether the invoking component is mounted or not
 * @see https://stackoverflow.com/a/64909334/2295034
 */
export const useMounted = () => {
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, [mounted]);
  return mounted;
};
//# sourceMappingURL=useMounted.js.map